import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=e6561bd4&"
import script from "./Photos.vue?vue&type=script&lang=js&"
export * from "./Photos.vue?vue&type=script&lang=js&"
import style0 from "./Photos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports